import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Spin } from 'antd';
import { ReactComponent as BackIcon } from '../../../assets/back-icon.svg';
import DetailsSection from './detailsSection';
import { fetchTenant, tenantDetailCleanupFunc } from '../redux/actions';
import './index.less';
import Notifications from './notifications';
import UserManager from './UserManager';

const TenantDetail = () => {
  const [isTenantUpdate, setIsTenantUpdate] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [canUpdate, setCanUpdate] = useState(true);

  const { currentTenantObj, fetchTenantDetailLoading, tenantDetailsIsEdit } =
    useSelector((state) => state.tenantsReducer);
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (currentTenantObj?._id) {
      setIsTenantUpdate(true);
    }
  }, [currentTenantObj]);

  useEffect(() => {
    if (params?.id) {
      setIsTenantUpdate(true);
      dispatch(fetchTenant(params?.id));
    } else if (pathname === '/profile') {
      setIsTenantUpdate(true);
      dispatch(fetchTenant(user.id));
    }

    return () => {
      dispatch(tenantDetailCleanupFunc());
      // dispatch(fetchTenantRegions());
    };
  }, [params.id]);

  return (
    <div className='page-top-div heading-parent-div'>
      <Row justify='space-between'>
        <Col>
          <span className='text-span'>
            {isTenantUpdate ? 'Update Institute' : 'Add Institute'}
          </span>
        </Col>
        <Col>
          <Button
            onClick={() => navigate('/institute-management')}
            icon={<BackIcon width={24} height={14} />}
            className='back-btn'
            size='middle'
          >
            BACK
          </Button>
        </Col>
      </Row>
      <Spin spinning={fetchTenantDetailLoading}>
        <div className='user-manager-parent-div'>
          <DetailsSection
            isTenantUpdate={isTenantUpdate}
            canUpdate={canUpdate}
          />
          {isTenantUpdate && <UserManager />}
          {false && (
            <Notifications
              isTenantUpdate={isTenantUpdate}
              canUpdate={canUpdate}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default TenantDetail;
